import Select from 'components/global/AutocompleteSelect';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Down from '../../../../images/onboarding/practitioner/down.svg';
import Search from '../../../../images/onboarding/practitioner/search.svg';

function Dropdown({
  label = undefined,
  value = null,
  onChange = () => {},
  options = [],
  clearable = false,
  searchable = false,
  multi = false,
  width = null,
  disabled = false,
  required = false,
  error = null,
}) {
  const className = required ? 'onboarding-label-required' : 'onboarding-label';

  return (
    <div style={{ position: 'relative', width: width || '200px' }}>
      {label && <p className={className}>{label}</p>}
      <Select
        value={value}
        onChange={onChange}
        popupIcon={searchable ? <Search className="search-icon" /> : <Down />}
        isClearable={clearable}
        isSearchable={searchable}
        options={options}
        placeholder=""
        isMulti={multi}
        isDisabled={disabled}
        noOptionsMessage={() => (
          <FormattedMessage defaultMessage="No results found" />
        )}
      />
      {error && <p className="onboarding-error">{error}</p>}
    </div>
  );
}

Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  clearable: PropTypes.bool,
  searchable: PropTypes.bool,
  multi: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
};

export default Dropdown;
